export default "__VITE_ASSET__806f1dd4__"